angular.module('impactx').config(['panelServiceProvider', PanelServiceConfig]);

function PanelServiceConfig(panelService) {

    tenderPanelColorDefinition();
    lotPanelColorDefinition();
    catalogPanelColorDefinition();
    productPanelColorDefinition();
    supplierPanelColorDefinition();

    function tenderPanelColorDefinition() {
        var tenderPanelColors = new Map();
        tenderPanelColors.set(0, "#37474F");
        tenderPanelColors.set(13, "#E65100");

        panelService.initializePanelColors('tender', tenderPanelColors);
    }

    function lotPanelColorDefinition() {
        var lotPanelColors = new Map();
        lotPanelColors.set(0, "#455A64");
        lotPanelColors.set(13, "#EF6C00");

        panelService.initializePanelColors('lot', lotPanelColors);
    }

    function catalogPanelColorDefinition() {
        var catalogPanelColors = new Map();
        catalogPanelColors.set(0, "#607D8B");
        catalogPanelColors.set(13, "#FB8C00");

        panelService.initializePanelColors('catalog', catalogPanelColors);
    }

    function productPanelColorDefinition() {
        var productPanelColors = new Map();
        productPanelColors.set(0, "#90A4AE");
        productPanelColors.set(13, "#FFA726");

        panelService.initializePanelColors('product', productPanelColors);
    }

    function supplierPanelColorDefinition() {
        var supplierPanelColors = new Map();
        supplierPanelColors.set(0, "#6A1B9A");
        supplierPanelColors.set(13, "#6A1B9A");

        panelService.initializePanelColors('supplier', supplierPanelColors);
    }
}